import PropTypes from 'prop-types';
import React from 'react';
import { Alert, Button, Col, Row, Spinner, Modal, Form, Badge } from 'react-bootstrap';
import coverSrc from 'assets/img/generic/4.jpg';
import { Link } from 'react-router-dom';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot } from '@fortawesome/free-solid-svg-icons'
import ProfileBanner from 'components/pages/user/ProfileBanner';
import VerifiedBadge from 'components/common/VerifiedBadge';
import OnBoardingService from './OnBoardingService';
import { useState } from 'react';
import DirectoryService from './DirectoryService';
const calcuateDueDate = (startDate, days) => {
  const dueDate = new Date(startDate);
  dueDate.setDate(dueDate.getDate() + days);
  return dueDate;
};
const Banner = ({ profile }) => {
  const [isLoadingAIOnboarding, setIsLoadingAIOnboarding] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [selectedTasks, setSelectedTasks] = useState({});
  const [isSavingTasks, setIsSavingTasks] = useState(false);
  const [iaOnboardingCompleted, setIaOnboardingCompleted] = useState(false);
  //const {identifier} = DirectoryService.retrieveLoggedProfile();
  const saveTasks = async (tasksToSave) => {
    setIsSavingTasks(true);
    try {
      const saveTasksPromises = tasksToSave.map(task =>
        OnBoardingService.createOnBoardingTask(task)
      );
      await Promise.all(saveTasksPromises);
      console.log('All tasks saved successfully');
      setShowConfirmDialog(false);
      setTasks([]);
      setSelectedTasks({});
      // Optionally refresh the profile or show success message
    } catch (error) {
      console.error('Error saving tasks:', error);
      // Handle errors, e.g., show an error message to the user
    } finally {
      setIsSavingTasks(false);
    }
  };
  const handleAIOnboarding = () => {
    // Implement AI onboarding logic here
    console.log('AI Onboarding initiated');
    setIsLoadingAIOnboarding(true);
    const profileLogged = JSON.parse(localStorage.getItem('profile'));  
    OnBoardingService.autoGenerateOnBoarding(profile)
      .then(response => {
        console.log('AI Onboarding response:', response);
        const generatedTasks = response.map((item, index) => ({
          id: index, // Add unique id for tracking
          type: item.category,
          text: item.description,
          dueDate: calcuateDueDate(new Date(), item.due_day), 
          priority: item.priority, 
          status: 'pending',
          title: item.task,
          employeeIdentifier: profile.identifier, 
          profileIdentifier: profileLogged.identifier,
          done: false,
          onboardingTask: true
        }));
        setTasks(generatedTasks);
        
        // Initialize all tasks as selected by default
        const initialSelection = {};
        generatedTasks.forEach((task, index) => {
          initialSelection[index] = true;
        });
        setSelectedTasks(initialSelection);

        // Show the confirmation dialog
        setShowConfirmDialog(true);
        setIaOnboardingCompleted(true);
      })
      .catch(error => {
        alert('Error during AI onboarding: ' + error.message);
        // Handle errors, e.g., show an error message to the user
      })
      .finally(() => {
        setIsLoadingAIOnboarding(false);
      });
  };

  const handleToggleTask = (taskIndex) => {
    setSelectedTasks(prev => ({
      ...prev,
      [taskIndex]: !prev[taskIndex]
    }));
  };

  const handleSelectAll = () => {
    const newSelection = {};
    tasks.forEach((_, index) => {
      newSelection[index] = true;
    });
    setSelectedTasks(newSelection);
  };

  const handleUnselectAll = () => {
    const newSelection = {};
    tasks.forEach((_, index) => {
      newSelection[index] = false;
    });
    setSelectedTasks(newSelection);
  };

  const handleSaveSelectedTasks = () => {
    const tasksToSave = tasks.filter((_, index) => selectedTasks[index]);
    if (tasksToSave.length === 0) {
      alert('Please select at least one task to save.');
      return;
    }
    saveTasks(tasksToSave);
  };

  const getSelectedCount = () => {
    return Object.values(selectedTasks).filter(Boolean).length;
  };

  console.log(profile);
  const avatar = profile !== null ? profile.avatar : null;
  const jobType =
    profile !== null &&
    profile.contract !== null &&
    profile.contract.jobType !== null
      ? profile.contract.jobType
      : "Don't forget to complete your job details!";
  const location =
    profile !== null &&
    profile.contract !== null &&
    profile.contract.location !== null
      ? profile.contract.location + ', ' + profile.contract.country
      : '';
  return (
    <>
      {/* Confirmation Dialog */}
      <Modal
        show={showConfirmDialog}
        onHide={() => !isSavingTasks && setShowConfirmDialog(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton={!isSavingTasks}>
          <Modal.Title>
            <FontAwesomeIcon icon="tasks" className="me-2" />
            Confirm Onboarding Tasks
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          <div className="mb-3">
            <p className="text-700">
              Review and select the tasks you want to include in the onboarding process.
              <Badge bg="secondary" className="ms-2">
                {getSelectedCount()} of {tasks.length} selected
              </Badge>
            </p>
            <div className="d-flex gap-2 mb-3">
              <Button
                variant="outline-primary"
                size="sm"
                onClick={handleSelectAll}
                disabled={isSavingTasks}
              >
                <FontAwesomeIcon icon="check-square" className="me-1" />
                Select All
              </Button>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={handleUnselectAll}
                disabled={isSavingTasks}
              >
                <FontAwesomeIcon icon="square" className="me-1" />
                Unselect All
              </Button>
            </div>
          </div>

          {tasks.map((task, index) => (
            <div
              key={index}
              className={`border rounded p-3 mb-2 ${
                selectedTasks[index] ? 'bg-light' : ''
              }`}
            >
              <Form.Check
                type="checkbox"
                id={`task-${index}`}
                checked={selectedTasks[index] || false}
                onChange={() => handleToggleTask(index)}
                disabled={isSavingTasks}
                label={
                  <div>
                    <div className="d-flex align-items-center justify-content-between">
                      <h6 className="mb-1">{task.title}</h6>
                      <div>
                        <Badge
                          bg={
                            task.priority === 'High'
                              ? 'danger'
                              : task.priority === 'Medium'
                              ? 'warning'
                              : 'info'
                          }
                          className="me-2"
                        >
                          {task.priority}
                        </Badge>
                        <Badge bg="secondary">{task.type}</Badge>
                      </div>
                    </div>
                    <p className="mb-1 text-700 fs--1">{task.text}</p>
                    <small className="text-500">
                      Due: {task.dueDate.toLocaleDateString()}
                    </small>
                  </div>
                }
              />
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmDialog(false)}
            disabled={isSavingTasks}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSaveSelectedTasks}
            disabled={isSavingTasks || getSelectedCount() === 0}
          >
            {isSavingTasks ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Saving...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon="save" className="me-2" />
                Save {getSelectedCount()} Task{getSelectedCount() !== 1 ? 's' : ''}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <ProfileBanner>
        <ProfileBanner.Header avatar={avatar || null} coverSrc={coverSrc} />
        <ProfileBanner.Body>
        <Row>
          <Col lg={8}>
            <h4 className="mb-1">
              {profile.firstName !== null
                ? profile.firstName + ' ' + profile.lastName
                : 'Complete the form'}{' '}
              <VerifiedBadge />
            </h4>
            <h5 className="fs-0 fw-normal">{jobType}</h5>
            <p className="text-500">{location}</p>
            {isLoadingAIOnboarding && (
              <>
              <Button variant="primary" size="sm" disabled>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Analyzing...this could take a few seconds
                </Button>
              </>
            )}
            {iaOnboardingCompleted && (
              <Alert variant="success" className='p-2 fs--1 mt-3 w-75'>
                AI Onboarding Completed. Check your tasks for details.
              </Alert>
            )}
            {profile.aiOnboarding === false &&
              isLoadingAIOnboarding === false && 
              iaOnboardingCompleted === false &&  (
                <Button
                  variant="primary"
                  size="sm"
                  onClick={handleAIOnboarding}
                >
                  <FontAwesomeIcon icon={faRobot} className="me-2" />
                  Auto-generate Onboarding
                </Button>
              )}
            <div className="border-dashed-bottom my-4 d-lg-none" />
          </Col>
          <Col className="ps-2 ps-lg-3">
            <Link to="#!">
              <Flex alignItems="center" className="mb-2">
                <FontAwesomeIcon
                  icon="envelope"
                  className="fs-3 me-2 text-700"
                />
                <div className="flex-1">
                  <h6 className="mb-0">{profile.email}</h6>
                </div>
              </Flex>
            </Link>
            <Link to="#!">
              <Flex alignItems="center" className="mb-2">
                <FontAwesomeIcon icon="mobile" className="fs-3 me-2 text-700" />
                <div className="flex-1">
                  <h6 className="mb-0">{profile.personalMobile}</h6>
                </div>
              </Flex>
            </Link>
          </Col>
        </Row>
      </ProfileBanner.Body>
    </ProfileBanner>
    </>
  );
};

Banner.propTypes = {
  profile: PropTypes.shape({
    avatar: PropTypes.any,
    contract: PropTypes.shape({
      country: PropTypes.any,
      jobType: PropTypes.any,
      location: PropTypes.string
    }),
    email: PropTypes.any,
    firstName: PropTypes.string,
    lastName: PropTypes.any,
    personalMobile: PropTypes.any
  })
};

export default Banner;
